module.exports = __webpack_public_path__ + "static/ons-desktop-d7e2abb715e6eeef36eb1f92a49f58be.jpg";